/* ---------- sticky sub-nav scrollspy ---------- */
(function(){
  var bar = document.querySelector('.subbar');
  if(!bar) return;
  var links = [].slice.call(bar.querySelectorAll('nav a[href^="#"]'));
  var map = [];
  links.forEach(function(a){
    var el = document.getElementById(a.getAttribute('href').slice(1));
    if(el) map.push({a:a, el:el});
  });
  if(!map.length) return;
  function setActive(a){
    links.forEach(function(l){ l.classList.toggle('active', l===a); });
  }
  function onScroll(){
    var line = bar.getBoundingClientRect().bottom + 8, cur = null;
    map.forEach(function(m){
      if(m.el.getBoundingClientRect().top <= line) cur = m.a;
    });
    setActive(cur);
  }
  var tick = false;
  window.addEventListener('scroll', function(){
    if(tick) return; tick = true;
    requestAnimationFrame(function(){ onScroll(); tick = false; });
  }, {passive:true});
  window.addEventListener('resize', onScroll);
  onScroll();
})();

/* ---------- mobile nav ---------- */
(function(){
  var btn = document.querySelector('.menu-toggle');
  var nav = document.getElementById('navigation');
  if(!btn || !nav) return;
  btn.addEventListener('click', function(){
    var open = nav.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.innerHTML = open ? 'CLOSE' : '<span class="bars" aria-hidden="true"><i></i></span>MENU';
  });
  nav.addEventListener('click', function(e){
    if(e.target.tagName === 'A'){
      nav.classList.remove('open');
      btn.setAttribute('aria-expanded','false');
      btn.innerHTML = '<span class="bars" aria-hidden="true"><i></i></span>MENU';
    }
  });
})();

/* ---------- reveal on scroll ---------- */
(function(){
  var items = document.querySelectorAll('.reveal');
  if(!items.length) return;
  if(!('IntersectionObserver' in window)){
    items.forEach(function(el){ el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  items.forEach(function(el){ io.observe(el); });
})();
